import classNames from "classnames";
import React from "react";
import { Icon, Popup } from "semantic-ui-react";
import { SemanticICONS } from "semantic-ui-react/dist/commonjs/generic";
import styles from "./SocialMediaIcon.module.scss";

type Props = {
  className?: string;
  icon: SemanticICONS;
  content?: string;
  onClick?: () => void;
  inverted?: boolean;
};

const SocialMediaIcon = ({
  className,
  icon,
  content,
  onClick,
  inverted = false,
}: Props) => {
  const innerIcon = (
    <Icon
      circular
      name={icon}
      inverted={inverted}
      size="large"
      onClick={onClick}
      className={classNames(styles.self, className)}
    />
  );
  return content ? (
    <Popup content={content} position="top center" trigger={innerIcon} />
  ) : (
    innerIcon
  );
};

export default SocialMediaIcon;
